<template>
  <div>
    <div class="vx-card">
      <div class="vx-card__body">
        <div class="flex gap-6 mb-4 justify-end">
          <vs-button
            type="filled"
            @click="downloadFile()"
            class="bg_purple px-4"
          >
            {{ $t("ExportAsCSV") }}
          </vs-button>
          <!-- <div class="flex">
            <div class="w-full">
              <vs-button
                @click="showFilters = !showFilters"
                class="bg_purple float-right"
              >
                <div class="px-3">
                  <feather-icon
                    icon="FilterIcon"
                    svgClasses="h-4 w-4"
                    class="ico"
                  />
                  {{ $t("Filter") }}
                </div>
              </vs-button>
            </div>
          </div> -->
        </div>
        <div class="vx-row px-4 flex flex-wrap items-end">
          <div class="flex-grow text-center" style="min-width: 250px">
            <ul class="typeReport">
              <li
                @click="changeTypeReport('serials')"
                :class="isType_Serials ? 'onType_Serials' : 'opacity-50'"
              >
                <label class="label">گزارش سریالی</label>
              </li>
              <li
                @click="changeTypeReport('accumulative')"
                :class="!isType_Serials ? 'onType_Serials' : 'opacity-50'"
              >
                <label class="label">گزارش تجمیعی</label>
              </li>
            </ul>
          </div>
          <div class="w-2/3 flex-grow flex gap-4 flex-wrap">
            <div class="flex-grow" style="min-width: 250px">
              <label class="vs-select--label datepicker-lb">{{
                $t("FromDate")
              }}</label>

              <date-picker
                v-model="model.FromDate"
                type="datetime"
                format="jYYYY-jMM-jDD HH:mm:ss"
                display-format="jYYYY-jMM-jDD HH:mm:ss"
                class="date-picker"
                :label="$t('FromDate')"
                :clearable="true"
              />
            </div>
            <div class="flex-grow" style="min-width: 250px">
              <label class="vs-select--label datepicker-lb">{{
                $t("ToDate")
              }}</label>

              <date-picker
                v-model="model.ToDate"
                type="datetime"
                format="jYYYY-jMM-jDD HH:mm:ss"
                display-format="jYYYY-jMM-jDD HH:mm:ss"
                class="date-picker"
                :label="$t('ToDate')"
                :clearable="true"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.typeReport {
  display: inline-flex;
  padding: 0 1em;
  border-radius: 4px;
  margin: 0;
  padding: 0;
  list-style: none;
  border: 1px solid rgb(202, 202, 202);
  background-color: rgb(230, 230, 230);
  height: 3em;
}
.label {
  display: inline-block;
  color: black;
  border-radius: 4px;
  transition: all 0.1s ease;
  width: 100%;
  text-align: center;
  align-content: center;
  padding: 10px 20px 0;
  height: 100%;
}

.onType_Serials {
  background-color: #007470;
  & .label {
    color: white;
  }
}
.vs-select--label {
  margin-top: 6px;
  margin-bottom: 2px;
  display: block;
}
</style>
<script>
import { mapActions } from "vuex";
import "../../../../assets/scss/vuesax-rtl/pages/_warehouse.scss";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  name: "warehouseManagement_Reports_",
  data() {
    return {
      showFilters: false,
      isType_Serials: false,
      modelForDownload: "",

      model: {
        FromDate: "",
        ToDate: "",
      },
    };
  },
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  methods: {
    ...mapActions({
      exportbaseOnStockDraftOrderAccumulative:
        "excel/exportbaseOnStockDraftOrderAccumulative",
      exportbaseOnStockDraftOrderSerials:
        "excel/exportbaseOnStockDraftOrderSerials",
    }),
    downloadFile() {
      if (this.model.FromDate || this.model.ToDate) {
        this.modelForDownload = "?";
        if (this.model.FromDate) {
          this.modelForDownload += "FromDate=" + this.model.FromDate;
        }
        if (this.model.FromDate && this.model.ToDate) {
          this.modelForDownload += "&";
        }
        if (this.model.ToDate) {
          this.modelForDownload += "ToDate=" + this.model.ToDate;
        }
      }
      if (this.isType_Serials) {
        this.exportbaseOnStockDraftOrderSerials(this.modelForDownload);
      } else {
        this.exportbaseOnStockDraftOrderAccumulative(this.modelForDownload);
      }
    },
    changeTypeReport(type) {
      if (type == "serials") {
        this.isType_Serials = true;
      } else {
        this.isType_Serials = false;
      }
    },
  },
};
</script>

<style></style>
